import { useTranslation } from 'react-i18next'

export const useComponentTranslation = (componentName: string) =>
  useTranslation('components', { keyPrefix: componentName })
